module.exports = "<p>\r\n  bc-filter works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/billing-control/bc-filter/bc-filter.component.html
// module id = ./src/app/billing-control/bc-filter/bc-filter.component.html
// module chunks = main